import React from "react";
import {FaRegStar, FaStar, FaStarHalfAlt,} from 'react-icons/fa';

interface IProps {
    grade: number;
}

export const StarRating = ({grade}: IProps) => {
    const fullStars = Math.floor(grade);
    const halfStar = (grade - fullStars) > 0;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);
    return (
        <span className="review-stars"  aria-hidden="true">
            {[...Array(fullStars)].map((e, i) => <FaStar key={`full-star-${i}`} className="me-1"/>)}
            {halfStar && <FaStarHalfAlt key={"half-star"} className="me-1"/>}
            {[...Array(emptyStars)].map((e, i) => <FaRegStar key={`empty-star-${i}`} className="me-1"/>)}
        </span>
    )
}